// @flow

import type { ReportData } from 'app/common/redux/reducers/ui/reportData';

export type ReportContentShow = {|
  type: 'REPORT_CONTENT_SHOW',
  payload: ReportData,
|};

export type ReportContentDismiss = { type: 'REPORT_CONTENT_DISMISS' };

export function showReportContent({
  id,
  isProduct,
  isPromoted,
  videoDuration,
  viewParameter,
  viewType,
  type,
}: ReportData) {
  return {
    type: 'REPORT_CONTENT_SHOW',
    payload: {
      id,
      isProduct,
      isPromoted,
      videoDuration,
      viewParameter,
      viewType,
      type,
    },
  };
}

export function dismissReportContent() {
  return {
    type: 'REPORT_CONTENT_DISMISS',
  };
}
